import { MapSearch as View } from 'ui-components'

import { Header } from 'header'
import { FeedSortInput } from './FeedSortInput'
import { VirtualizedMapGrid } from './VirtualizedMapGrid'

const Main = () => {
  return (
    <View
      slots={{
        Header: () => <Header showSearch={true} />,
        FeedSortInput,
        MapGrid: VirtualizedMapGrid
      }}
    />
  )
}

export { Main }
